
import { useState, useEffect } from 'react';
import { User, Session } from '@supabase/supabase-js';
import { authStore } from '@/stores/authStore';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only log in development or for debugging specific issues
    if (process.env.NODE_ENV === 'development') {
      console.log('🔐 [USE AUTH] Component subscribing to auth store');
    }
    
    const unsubscribe = authStore.subscribe((state) => {
      setUser(state.user);
      setSession(state.session);
      setLoading(state.loading);
    });

    return () => {
      if (process.env.NODE_ENV === 'development') {
        console.log('🔐 [USE AUTH] Component unsubscribing from auth store');
      }
      unsubscribe();
    };
  }, []);

  return {
    user,
    session,
    loading,
    signUp: authStore.signUp.bind(authStore),
    signIn: authStore.signIn.bind(authStore),
    signOut: authStore.signOut.bind(authStore)
  };
};
